import React from "react";
import { NavLink } from "react-router-dom";
import { Home, Cloud, Plus, Heart, UserRound } from "lucide-react";

import { dispatchAppEvent } from "../../lib/app-events";
import { cn } from "../../lib/utils";
import type { CurrentUser } from "../../types/user";

// Bottom navigation for the native app (see the "Home feed" screen in the
// mobile mockup). The website keeps its header navigation instead.
export function MobileTabBar({ currentUser }: { currentUser: CurrentUser | null }) {
  const profilePath =
    currentUser?.username && currentUser?.id ? `/user/${currentUser.username}/${currentUser.id}?view=mine` : null;

  const itemClass = ({ isActive }: { isActive: boolean }) =>
    cn(
      "flex flex-col items-center justify-center gap-0.5 min-h-[44px] text-[11px] font-medium",
      isActive ? "text-[#14213d] dark:text-white font-semibold" : "text-slate-500 dark:text-slate-400"
    );

  return (
    <nav
      aria-label="Main"
      className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-5 items-center border-t border-slate-200 bg-white px-3 pt-2 pb-[max(env(safe-area-inset-bottom),8px)] dark:border-slate-700 dark:bg-slate-900"
    >
      <NavLink to="/" end className={itemClass}>
        <Home className="h-6 w-6" aria-hidden="true" />
        Home
      </NavLink>
      <NavLink to="/quotes/authors" className={itemClass}>
        <Cloud className="h-6 w-6" aria-hidden="true" />
        Authors
      </NavLink>
      <button
        type="button"
        aria-label="Add inspiration"
        onClick={() =>
          currentUser ? dispatchAppEvent("inspirelens:openCreateModal") : dispatchAppEvent("inspirelens:openAuth", "login")
        }
        className="justify-self-center -mt-5 grid h-[52px] w-[52px] place-items-center rounded-[18px] bg-[#fc991d] text-slate-900 shadow-lg shadow-orange-500/30"
      >
        <Plus className="h-7 w-7" strokeWidth={2.5} aria-hidden="true" />
      </button>
      <NavLink to="/liked" className={itemClass}>
        <Heart className="h-6 w-6" aria-hidden="true" />
        Liked
      </NavLink>
      {profilePath ? (
        <NavLink to={profilePath} className={itemClass}>
          <UserRound className="h-6 w-6" aria-hidden="true" />
          Profile
        </NavLink>
      ) : (
        <button type="button" onClick={() => dispatchAppEvent("inspirelens:openAuth", "login")} className={itemClass({ isActive: false })}>
          <UserRound className="h-6 w-6" aria-hidden="true" />
          Log in
        </button>
      )}
    </nav>
  );
}
